import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=0dc60280&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"
import style0 from "./alarm.vue?vue&type=style&index=0&id=0dc60280&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc60280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc60280')) {
      api.createRecord('0dc60280', component.options)
    } else {
      api.reload('0dc60280', component.options)
    }
    module.hot.accept("./alarm.vue?vue&type=template&id=0dc60280&scoped=true", function () {
      api.rerender('0dc60280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report-download/components/alarm.vue"
export default component.exports